<template>
  <div v-if="!showRequest">
    <app-history @clicked="$router.push('/marital-history')" />
    <v-card class="fullForm">
      <div class="fullText">
        شما در اين بخش قادر خواهيد بود، بصورت سيستمي،‌ درخواست تغییر وضعیت تاهل
        خود را ارسال فرمائيد.
        <br />
        پیش از ثبت ازدواج یا طلاق لطفا فرآیند ثبت نام مشخصات همسر را در سایت
        مرکز مدیریت حوزه علمیه خراسان انجام دهید.
        <br />
        لینک ثبت نام:
        <a href="https://profile.hozehkh.com/fard/add">https://profile.hozehkh.com/fard/add</a>
        <br />
        درخواست شما توسط واحد پذیرش مركز مديريت بررسي و در صورت تاييد، وضعیت
        تاهل جدید براي شما ثبت خواهد شد.
        <br />
        بعد از اظهار نظر نهایی، اطلاع رساني از طريق سامانه طلوع به شما صورت
        خواهد گرفت.
        <br />
        ضمنا شما مي توانيد در بخش مشاهده سوابق اقدام به پيگيري درخواست خود
        نمائيد.
        <br />
        دقت شود پس از دريافت پيامك مبني بر صدور مدرك، جهت تحويل مراجعه نماييد.
        <br />
        در صورت بروز هرگونه مشکل با واحد پذیرش 32008335 و 32008336 تماس حاصل
        نمایید.
        <br />
        <br />
      </div>
      <v-row class="ltr">
        <v-btn color="primary white--text" class="request" rounded @click="handleShowRequest">
          ثبت {{ changeText }}
        </v-btn>
      </v-row>
    </v-card>
  </div>
  <div v-else>
    <v-card class="form">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>تاریخ ثبت {{ changeText }}:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-btn class="form-center" color="orange white--text" rounded @click="onClickDate(1)">
            {{ actionSelected ? actionDate : "انتخاب تاریخ" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> کد ملی همسر: </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="nationalCode" maxlength="10" :oninput="onInput"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>تاریخ تولد همسر:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-btn class="form-center" color="orange white--text" rounded @click="onClickDate(2)">
            {{ birthSelected ? birthDate : "انتخاب تاریخ" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>توضیحات:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="comment" no-resize></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <v-file-input :label="'پيوست صفحه مربوط به ' + changeText + ' - شناسنامه خود'" v-model="image"></v-file-input>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <v-file-input :label="'پيوست صفحه مربوط به ' + changeText + ' - شناسنامه همسر'"
            v-model="image2"></v-file-input>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn color="primary white--text" class="register" rounded @click="applyRequest" :disabled="apiRunning">
          {{ apiRunning ? "لطفا منتظر بمانید..." : "ثبت" }}
        </v-btn>
      </v-row>
    </v-card>
    <date-picker ref="datepicker1" v-model="actionDate" :editable="false" :auto-submit="true" element="fileInput1"
      :max="today" @change="onChangeDate($event, 1)"></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <date-picker ref="datepicker2" v-model="birthDate" :editable="false" :auto-submit="true" element="fileInput2"
      :max="today" @change="onChangeDate($event, 2)"></date-picker>
    <input id="fileInput2" ref="fileInput2" />
  </div>
</template>

<script>
import { requestMarital } from "@/api/marital";
import { TODAY } from "@/utils/constants";
import moment from "moment-jalaali";
import HistoryButton from "@/components/HistoryButton";
export default {
  data() {
    return {
      today: TODAY,
      showRequest: false,
      image: null,
      image2: null,
      nationalCode: "",
      actionDate: TODAY,
      birthDate: TODAY,
      actionSelected: false,
      birthSelected: false,
      comment: "",
    };
  },
  components: {
    appHistory: HistoryButton,
  },
  methods: {
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    onChangeDate($event, input) {
      let date = moment($event).format("jYYYY/jMM/jDD");
      if (input == 1) {
        this.actionDate = date;
        this.actionSelected = true;
      } else {
        this.birthDate = date;
        this.birthSelected = true;
      }
    },
    /**
     * check user input and  then send khorooj request
     */
    applyRequest() {
      var text = "";
      if (!this.actionSelected) {
        text = "لطفا تاریخ " + changeText + " را انتخاب کنید.";
      } else if (this.nationalCode == "") {
        text = "کد ملی همسر نباید خالی باشد.";
      } else if (!this.birthSelected) {
        text = "لطفا تاریخ تولد همسر را انتخاب کنید.";
      } else if (this.image == null) {
        text = "تصویر شناسنامه خود بایستی انتخاب شود..";
      } else if (this.image2 == null) {
        text = "تصویر شناسنامه همسر بایستی انتخاب شود..";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        requestMarital(
          this.image,
          this.image2,
          this.actionDate,
          this.maritalInfo.IsMarried ? "0" : "1",
          this.nationalCode,
          this.birthDate,
          this.comment
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
            this.$store.commit("SET_API_RUNNING", false);
            if (data.Success) {
              this.goToIndex();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
    goToIndex() {
      this.$router.push({ path: "/index" });
    },
    handleShowRequest() {
      window.scrollTo(0, 0)
      this.$router.push({
        query: {

          showRequest: "true"
        }
      });

    }
  },
  /**
   * get khorooji meta data
   */
  created() {
    if (this.$route.query.showRequest) {
      this.$router.replace({
        query: {}
      })
    }
    this.$store.dispatch("getMaritalInfo");
  },
  computed: {
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
    maritalInfo() {
      return this.$store.getters.maritalInfo;
    },
    changeText() {
      return this.maritalInfo.IsMarried ? "طلاق" : "ازدواج";
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  watch: {

    '$route'(to, from) {
      this.showRequest = !!this.$route.query.showRequest;
      window.scrollTo(0, 0)
    }
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}

.request {
  width: 300px !important;
  margin: 15px;
}

.register {
  width: 300px !important;
  margin: 15px auto;
}

@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
